export default "__VITE_ASSET__DqqVNzcJ__"